import { Link } from 'react-router-dom';
import { useSEO } from '@/hooks/useSEO';

export default function NotFound() {
  useSEO({
    title: '页面不存在 - 篮球比分',
    description: '您访问的页面不存在，返回首页查看最新篮球比分与赛事资讯。',
  });

  return (
    <div className="px-4 md:px-6 py-20 md:py-28 flex flex-col items-center text-center animate-fade-up min-h-[60vh] justify-center">
      <span className="font-heading font-extrabold text-7xl md:text-9xl text-primary-500">404</span>
      <h1 className="mt-4 font-heading font-bold text-2xl text-foreground-900">页面走丢了</h1>
      <p className="mt-2 text-sm md:text-[15px] text-foreground-500 max-w-md">
        您访问的页面可能已被移除、更名，或者链接有误。不妨从下方入口继续浏览赛事与资讯。
      </p>
      <div className="mt-7 flex items-center gap-3 flex-wrap justify-center">
        <Link to="/" className="h-10 px-5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold flex items-center cursor-pointer whitespace-nowrap">
          返回首页
        </Link>
        <Link to="/category/all" className="h-10 px-5 rounded-md border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600 text-sm font-medium flex items-center cursor-pointer whitespace-nowrap transition-colors">
          浏览全部赛事
        </Link>
        <Link to="/news" className="h-10 px-5 rounded-md border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600 text-sm font-medium flex items-center cursor-pointer whitespace-nowrap transition-colors">
          查看新闻资讯
        </Link>
      </div>
    </div>
  );
}